import { toCamelCase } from 'util/string-transform';

export const dagsterUrlPrefix = 'dagster';
export const queryKey = toCamelCase(dagsterUrlPrefix);

export const jobs = {
	arbin_cycler_and_thermal_by_test_phrase_job: 'Pipeline Distribute Arbin Process Jobs By Test Phrase',
};
